export default "__VITE_ASSET__2407c880__"